import AccountContext from 'context/AccountContext';
import { useContext } from 'react';
import {
  AccessPermitPoolingGroupCombinedInfo,
  Maybe,
} from 'types/generatedSchemaTypes';

const useGetBenefitNameForAccessPermitPoolingGroup = (
  poolingGroup: Maybe<AccessPermitPoolingGroupCombinedInfo> | undefined
) => {
  const {
    customer: { poolingBenefits },
  } = useContext(AccountContext);

  return poolingBenefits?.find(
    (benefit) => benefit.benefitTargetUid === poolingGroup?.uid
  )?.name;
};

export default useGetBenefitNameForAccessPermitPoolingGroup;
